exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bistro-weborders-body-with-items[data-v-ac7144f0]{padding-top:10vh;padding-bottom:16vh;height:80%}.bistro-weborders-body[data-v-ac7144f0]{margin-top:40vh}.mercadoPagoIFrame[data-v-ac7144f0]{height:100vh;width:100vw}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ac7144f0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/SelfServiceCheckout.vue
// module id = 496
// module chunks = 0